module.exports = require('dateformat');



//////////////////
// WEBPACK FOOTER
// ./~/ES/lib/dateformat.js
// module id = 42
// module chunks = 0 1 2 3 4